import React from 'react'

export default function CloseSesion(props) {
    //const { style, color } = props;

    return(
        <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#2196C0" d="M4.79052 11.2699H0.781505C0.355229 11.2699 0 10.9299 0 10.4999C0 10.0799 0.355229 9.7299 0.781505 9.7299H4.79052L4.79083 4.95C4.79083 2.5 6.85611 0.5 9.38609 0.5H14.4254C16.945 0.5 19 2.5 19 4.94V16.06C19 18.51 16.945 20.5 14.4047 20.5H9.37576C6.85611 20.5 4.79083 18.51 4.79083 16.07V11.27H11.1932L9.54099 12.87C9.23119 13.17 9.23119 13.66 9.54099 13.96C9.69588 14.11 9.90241 14.18 10.1089 14.18C10.3051 14.18 10.5117 14.11 10.6666 13.96L13.6819 11.05C13.8368 10.91 13.9194 10.71 13.9194 10.5C13.9194 10.3 13.8368 10.1 13.6819 9.96L10.6666 7.05C10.3568 6.75 9.85078 6.75 9.54099 7.05C9.23119 7.35 9.23119 7.84 9.54099 8.14L11.1932 9.73H4.79083L4.79052 11.2699Z"/>
        </svg>
    )
}